import { render, staticRenderFns } from "./UpdateCredit.vue?vue&type=template&id=054be8b6&"
import script from "./UpdateCredit.vue?vue&type=script&lang=js&"
export * from "./UpdateCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports